import { render, staticRenderFns } from "./AssignRolesModal.vue?vue&type=template&id=7dc143e9&scoped=true"
import script from "./AssignRolesModal.vue?vue&type=script&lang=js"
export * from "./AssignRolesModal.vue?vue&type=script&lang=js"
import style0 from "./AssignRolesModal.vue?vue&type=style&index=0&id=7dc143e9&prod&lang=scss"
import style1 from "./AssignRolesModal.vue?vue&type=style&index=1&id=7dc143e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc143e9",
  null
  
)

export default component.exports